import { useEventListener } from './use-event-listener'

export const useKeyboardShortcuts = ({ left, right }: Record<string, AnyFunction>) => {
  useEventListener<KeyboardEvent>('keydown', event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      left()
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault()
      right()
    }
  })
}
